import '../../pages/Login/Login.css';
import './Pop.css';
import React, { useContext, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Container, Row, Col } from 'reactstrap';
import { AppContext } from '../../context/AppContext';
import PortalWrapper from "./PortalWrapper"; 

const LoginPop = ({ onClose, onSwitchToRegister }) => {
  const navigate = useNavigate();
  const { setToken, setShowForget } = useContext(AppContext);

  const [formData, setFormData] = useState({ phone: '', password: '' });
  const [errors, setErrors] = useState({});
  const [serverMessage, setServerMessage] = useState('');

  const handleChanges = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});
    try {
      const response = await fetch('https://dashboard.tiktaka.com/api/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(formData)
      });
      const data = await response.json();
      setServerMessage(data.message);

      if (response.ok) {
        alert("✅ تم التسجيل بنجاح!");
        localStorage.setItem('token', data.token);
        setToken(data.token);
        navigate('/');
        onClose();
      } else if (response.status === 422) {
        setErrors(data.errors);
      }
    } catch (error) {
      alert('⚠️ حصل خطأ في الاتصال بالسيرفر');
    }
  };

  return (
    <PortalWrapper>
      <div className="popup-overlay">
        <div className="popup-panel">
          <div className="panel-header">
            <button onClick={onClose}>✖</button>
          </div>
          <div className="panel-body">
            <Container>
              <Row>
                <Col lg='6' md='6' sm='12' className='loginBox'>
                  <form onSubmit={handleSubmit} className='material-form'>
                    <h1>Login</h1>

                    {serverMessage && <div style={{ color: "red", marginBottom: "10px" }}>{serverMessage}</div>}

                    <div className='input-field'>
                      <input type='text' placeholder='phone or username' name='phone' value={formData.phone} onChange={handleChanges} />
                      <label>Phone Or UserName</label>
                      <span className="bar"></span>
                      {errors.phone && <div style={{ color: "red", fontSize: "12px" }}>{errors.phone[0]}</div>}
                    </div>

                    <div className='input-field'>
                      <input type='password' placeholder='Password' name='password' value={formData.password} onChange={handleChanges} />
                      <label>Password</label>
                      <span className="bar"></span>
                      {errors.password && <div style={{ color: "red", fontSize: "12px" }}>{errors.password[0]}</div>}
                    </div>

                    <div className='rememberForget'>
                      <Link to="#" onClick={(e) => { e.preventDefault(); onSwitchToRegister(); }}>Create new account</Link>
                       / 
                       <Link to="#" onClick={(e) => { 
                        e.preventDefault(); 
                        onClose(); 
                        setShowForget(true); 
                      }}>Forget Password</Link>
                    </div>
                    <button type='submit'>Submit</button>
                  </form>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      </div>
    </PortalWrapper>
  );
};

export default LoginPop;
